import { map } from "rxjs";
export function apiUploadCustomerAvatar(customerManagementService, file) {
    return customerManagementService.customerManagementCustomerUploadAvatar({
        body: { File: file },
    });
}
export function apiUploadSupplierAvatar(customerManagementService, file) {
    return customerManagementService.customerManagementSupplierUploadAvatar({
        body: { File: file },
    });
}
export function apiUploadUserAndShopAvatar(mediaService, file) {
    return mediaService.mediaAvatarUpload({ body: { File: file } }).pipe(map((url) => {
        return { urlImageProxy: url };
    }));
}
//# sourceMappingURL=upload-avatar.js.map